import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Pet } from 'src/app/interfaces/pet';

@Component({
  selector: 'app-petplan-decline-insurance-modal',
  templateUrl: './petplan-decline-insurance-modal.component.html',
  styleUrls: ['./petplan-decline-insurance-modal.component.scss']
})
export class PetplanDeclineInsuranceModalComponent {

  @Input('eligiblePet') public eligiblePet: Pet;

  constructor(public activeModal: NgbActiveModal) {}
}
